import { render, staticRenderFns } from "./title-actions-button.vue?vue&type=template&id=2fb02087"
import script from "./title-actions-button.vue?vue&type=script&lang=js"
export * from "./title-actions-button.vue?vue&type=script&lang=js"
import style0 from "./title-actions-button.vue?vue&type=style&index=0&id=2fb02087&prod&theme=dark-theater&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports